import { createFileRoute } from '@tanstack/react-router';
import DonationDetails from '@Views/Donations/Donations/DonationDetails';

export const Route = createFileRoute('/donations/$donationId/')({
    component: DonationDetails,
});
